const Wind = (): JSX.Element => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 64 64"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="none"
      stroke="#000000"
      stroke-width="2"
      stroke-miterlimit="10"
      d="M55,40c4.565,0,8-3.435,8-8c0-4.565-3.435-9-8-9
	c0-11.414-9.586-20-21-20C23.898,3,14.8,9.423,13,19c0,0-1.165,0-2,0C5.292,19,1,24.292,1,30s4.292,10,10,10"
    />
    <path
      fill="none"
      stroke="#000000"
      stroke-width="2"
      stroke-miterlimit="10"
      d="M27,58c0,2.761,2.238,5,5,5s5-2.239,5-5
	s-2.238-5-5-5H2"
    />
    <path
      fill="none"
      stroke="#000000"
      stroke-width="2"
      stroke-miterlimit="10"
      d="M40,42c0-2.761,2.238-5,5-5s5,2.239,5,5
	s-2.238,5-5,5H4"
    />
  </svg>
);

export default Wind;
